<template>
    <div>
        <h3>外部記事をリンクする</h3>
        <div>
            <p>
                静的なOGP出力に対応しているサイト・サービスの記事やコンテンツにリンクを貼ることができます。
                リンクした記事は通常の記事と同じように見えますが、外部サイトへ遷移するアイコン
                <i class="fas fa-external-link-alt"></i>
                が付与されます。
                記事をクリックすると、貸し本棚ではなく、リンク先のサイトが新規タブで開きます。
            </p>
            <p>
                記事のリンクは、noteやはてなブログなどの外部記事に貼ることもできますが、
                小説投稿サイトの作品にリンクすることもできます。
                特定の外部サイトだけで公開しているご自身の作品にリンクを貼ることで、
                転載の必要なくご自身の作品集を作ることもできます。
            </p>
            <p>
                <span class="font-weight-bold text-danger">
                    外部記事リンク機能によって他人の記事やコンテンツにリンクを貼ることはガイドライン違反となります。
                </span>
                ご自身の作成した記事の中から外部記事へリンクすることは問題ありません。
            </p>

            <h4>リンクの手順</h4>
            <p>
                記事メニューから「外部記事を読み込む」をクリックして、リンク画面を開きます。
            </p>
            <img src="/img/help/article/05.png" alt="記事リンク" class="img-thumbnail mb-3">
            <p>
                リンク先の記事のURLをコピーして、URL欄に貼り付けEnterをクリックしてください。
                正常に読み込まれると、記事カードが表示されます。
            </p>
            <p>
                静的OGPに対応していなかったり、その他の問題があって解析できない場合は、エラーが表示されます。
            </p>
            <p>
                公開先を選択して、「公開」ボタンをクリックして保存します。
                記事リンクは下書き保存できません。
            </p>
            <h5>twitterタグ優先</h5>
            <p>
                <span class="font-weight-bold">twitterタグ優先</span>
                にチェックをつけると、ogpタグの代わりにtwitterタグを優先読み込みします。
                twitterタグがなければogpタグのみ読み込みます。
            </p>
            <p>
                この設定は保存されません。
            </p>

        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "外部記事をリンクする | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>